export default function MultiSelectInput({
  label,
  name,
  options = [],
  values = [],
  onChange,
  hint = "Hold Ctrl (Windows) or Command (Mac) to select more than one.",
  size = 6,
}) {
  function handleChange(event) {
    const next = Array.from(event.target.selectedOptions, (option) => option.value);
    onChange({ target: { name, value: next } });
  }

  return (
    <label className="field">
      <span className="field-label">{label}</span>
      {hint ? <span className="field-hint">{hint}</span> : null}
      <select
        className="field-select field-select--multi"
        name={name}
        multiple
        size={size}
        value={values}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
